// extracted by mini-css-extract-plugin
export default {"dot":"styles-module__dot__src-labstep-web-components-EntityUser-Avatar-_VK8OL"};